/**
 * Form liabilities popup script
 */
 class FinHub_FormLiabilitiesPopup {
  constructor() {
    this.initState();
  }

  initState() {
    this.stepLiabilitiesPopup = $('.liabilities-popup');

    if (this.stepLiabilitiesPopup.length) {
      this.initFormLiabilities();
    }
  }

  initFormLiabilities () {
    this.stepFormLiabilitiesPopup = $('.form-liabilities-popup');
    let formHelperLiabilitiesPopup = new FinHub_FormHelper(this.stepFormLiabilitiesPopup);
    this.addNewLiabilities = $('.step-liabilities').find('.add-new-liabilities');
    this.cancelNewLiabilities = this.stepLiabilitiesPopup.find('.cancel-submit');
    this.submitPopup = this.stepFormLiabilitiesPopup.find('.form-incomes-liabilities-popup-submit');
    let liabilitiesWithBankIDs = [];
    this.stepFormLiabilitiesPopup.find('input[data-show-bank-select="1"]').each((i, field) => {
      liabilitiesWithBankIDs.push($(field).val());
    });
    
    formHelperLiabilitiesPopup.formDependencies([
      {
        field: 'bank_id',
        dependsOn: 'input[name="liability_id"]',
        showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
      },
      {
        field: 'payoff_amount',
        dependsOn: 'input[name="liability_id"]',
        showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
      },
      {
        field: 'instalment_currency',
        dependsOn: 'input[name="liability_id"]',
        showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
      },    
      {
        field: 'incomes-liabilities-2-payoff_amount_currency_name',
        dependsOn: 'select[name="incomes-liabilities-2-payoff_amount_currency_id"]',
        showOn: () => {
          let selectedCurrency = this.stepFormLiabilitiesPopup.find('select[name="incomes-liabilities-2-payoff_amount_currency_id"]').find(":selected");

          if (!selectedCurrency.length) {
            return false;
          }

          let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
          return selectedCurrencyCode === 'OTHER';
        }
      },    
      {
        field: 'incomes-liabilities-2-instalment_amount_currency_name',
        dependsOn: 'select[name="incomes-liabilities-2-instalment_amount_currency_id"]',
        showOn: () => {
          let selectedCurrency = this.stepFormLiabilitiesPopup.find('select[name="incomes-liabilities-2-instalment_amount_currency_id"]').find(":selected");

          if (!selectedCurrency.length) {
            return false;
          }

          let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
          return selectedCurrencyCode === 'OTHER';
        }
      }
    ]);

    this.addNewLiabilities.on('click', e => {
      e.preventDefault();
      this.stepLiabilitiesPopup.removeClass('is-hidden');
    });

    this.cancelNewLiabilities.on('click', e => {
      if (e) {
        e.preventDefault();
      }
      
      this.stepFormLiabilitiesPopup[0].reset();
      this.stepLiabilitiesPopup.addClass('is-hidden');
      $("*[data-fh-name]").addClass('is-hidden');
    });

    this.submitPopup.on('click', e => {
      e.preventDefault();
      let result = formHelperLiabilitiesPopup.formValidate();

			if (result) {
        let serializedData = this.stepFormLiabilitiesPopup.serializeArray();
        serializedData = this.serializeArrayToJSON(serializedData);
        $(document).trigger('finhub-add-liability', serializedData);
        this.cancelNewLiabilities.trigger('click');
			}
    });
  }

  serializeArrayToJSON (arrayToConvert) {
    let outputJSON = {};

    for (let i = 0; i < arrayToConvert.length; i++) {
      let pair = arrayToConvert[i];

      if (pair.value === '' || pair.value === null) {
        continue;
      }
      
      outputJSON[pair.name] = pair.value;
    }

    return JSON.stringify(outputJSON);
  }
}